import WaypointWithLine from './WaypointWithLine';

export default WaypointWithLine;
